'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimplePrompt = function (_React$Component) {
  _inherits(SimplePrompt, _React$Component);

  function SimplePrompt(props) {
    _classCallCheck(this, SimplePrompt);

    var _this = _possibleConstructorReturn(this, (SimplePrompt.__proto__ || Object.getPrototypeOf(SimplePrompt)).call(this, props));

    _this.handleChange = function (event) {
      _this.setState({ value: event.target.value });
    };

    _this.maybeSubmit = function (event) {
      if (event.key === 'Enter') {
        _this.setState({ value: '' });
        _this.props.onSubmit(event.target.value);
      }
    };

    _this.state = { value: props.initialValue };
    return _this;
  }

  _createClass(SimplePrompt, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('input', {
        autoFocus: true,
        type: 'text',
        value: this.state.value,
        onChange: this.handleChange,
        onKeyDown: this.maybeSubmit,
        placeholder: this.props.placeholder
      });
    }
  }]);

  return SimplePrompt;
}(_react2.default.Component);

SimplePrompt.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string.isRequired,
  initialValue: _propTypes2.default.string
};

SimplePrompt.defaultProps = {
  initialValue: ''
};

exports.default = SimplePrompt;


//////////////////
// WEBPACK FOOTER
// ./~/react-commander/lib/components/SimplePrompt.js
// module id = 836
// module chunks = 107818501498521